import { render, staticRenderFns } from "./AppTopbarGranCliente.vue?vue&type=template&id=47ab1e30&"
import script from "./AppTopbarGranCliente.vue?vue&type=script&lang=js&"
export * from "./AppTopbarGranCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports